<template>
  <div class="container">
    <!-- Header -->
    <div class="header">
      <h1 style="font-size: large; margin-bottom: 0;">Financing & Payments</h1>
      <a-button
        :loading="exportLoading"
        @click="exportData"
        style="border-radius: 6px; background: #fff; color: #0f3659"
        icon="upload"
      >
        Export
      </a-button>
    </div>

    <!-- Navigation Tabs -->
    <div class="tabs-container">
      <a-tabs v-model="activeTab" class="custom-tabs">
        <a-tab-pane key="invoices" tab="Invoices">
          <InvoicesTab />
        </a-tab-pane>
        <a-tab-pane key="disbursements" tab="Disbursements">
          <DisbursementsTab />
        </a-tab-pane>
        <a-tab-pane key="repayment-requests" tab="Repayment Requests">
          <RepaymentRequestsTab />
        </a-tab-pane>
        <a-tab-pane key="wallets" tab="Wallets">
          <WalletsTab />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import InvoicesTab from './InvoicesTab.vue'
import DisbursementsTab from './DisbursementsTab.vue'
import RepaymentRequestsTab from './RepaymentRequestsTab.vue'
import WalletsTab from './WalletsTab.vue'

export default {
  name: "Financing",
  components: {
    InvoicesTab,
    DisbursementsTab,
    RepaymentRequestsTab,
    WalletsTab
  },
  props: {
    sellerId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      activeTab: this.$route.query.tab || 'invoices',
      exportLoading: false
    }
  },
  created() {
    // Ensure the activeTab is set from URL query parameter on component creation
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
  },
  watch: {
    activeTab(newTab) {
      // Update URL when tab changes
      this.$router
        .replace({
          query: { ...this.$route.query, tab: newTab },
        })
        .catch(() => {});
    },
  },
  methods: {
    async exportData() {
      this.exportLoading = true
      try {
        // Export logic here
        this.$message.success('Data exported successfully')
      } catch (error) {
        this.$message.error('Export failed')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 100%;
  margin: 0 !important;
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tabs-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
}

.custom-tabs >>> .ant-tabs-bar {
  border: 0 !important;
}

.custom-tabs >>> .ant-tabs-nav {
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
}

.custom-tabs >>> .ant-tabs-tab {
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
  flex: 1;
  text-align: center;
}

.custom-tabs >>> .ant-tabs-tab {
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
}

.custom-tabs >>> .ant-tabs-tab-active {
  color: #26a246;
}

.custom-tabs >>> .ant-tabs-ink-bar {
  background-color: #26a246;
  height: 3px;
  bottom: -1px;
}
</style> 